(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    /* The accordions open and close on a transition instead of appearing.
     `<details>` reveals its content in the same frame it gains `open`, so CSS
     alone can animate neither half: opening has no from-state, and closing has
     already hidden the content before a transition could run. The click is
     taken over so the attribute and the class move at the right moments — the
     attribute first on open, the attribute last on close.

     Exposed as `window.etreeAccordions(root)` and idempotent, because the cart
     page replaces its own markup: a quantity change re-renders the section and
     the help rows come back as fresh elements (see `render()` in
     sections/cart-drawer.liquid). Re-running this over them is what keeps them
     working; `data-accordion-bound` is what stops the rows that survived from
     being bound twice and toggling themselves shut. */
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function bind(root) {
      (root || document).querySelectorAll('.accordion').forEach(function (item) {
        if (item.dataset.accordionBound) return;
        item.dataset.accordionBound = '1';

        var summary = item.querySelector('.accordion__summary');
        var panel = item.querySelector('.accordion__panel');
        if (!summary || !panel) return;

        /* A row rendered open — none are today, but a merchant can set one — has
           to start in the open class or its first close would animate from
           nothing. */
        if (item.open) item.classList.add('is-open');

        summary.addEventListener('click', function (event) {
          event.preventDefault();

          if (reduced.matches) {
            item.open = !item.open;
            item.classList.toggle('is-open', item.open);
            return;
          }

          if (item.open) {
            item.classList.remove('is-open');
            /* `transitionend` and not a timer: the row closes when the row has
               finished closing. Guarded on the property because the summary's own
               colour transition bubbles up here too. */
            panel.addEventListener('transitionend', function done(e) {
              if (e.propertyName !== 'grid-template-rows') return;
              panel.removeEventListener('transitionend', done);
              item.open = false;
            });
            return;
          }

          item.open = true;
          /* Two frames. One is not enough: the class would land in the same style
             recalculation as the attribute, and 0fr -> 1fr would have no
             from-state to interpolate from. */
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              item.classList.add('is-open');
            });
          });
        });
      });
    }

    window.etreeAccordions = bind;
    bind(document);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dialog-motion"] && !Shopify.designMode) return;
  try {
    (function () {
    /* The one thing worth branching on. `transition-behavior: allow-discrete`
       and `@starting-style` are both supported in WebKit, so probing those
       would wrongly report the native path as available. */
    var native = window.CSS && CSS.supports && CSS.supports('overlay', 'auto');
    if (native) return;

    /* Falls back to a timer if `transitionend` never arrives — a dialog whose
       closing rule changes nothing, or one closed while the tab is hidden and
       transitions do not run. Slightly longer than the 420ms the drawers take
       so the event wins the race whenever it is coming at all. */
    var FALLBACK_MS = 520;

    var wrap = function (dialog) {
      if (dialog.dataset.motionWrapped) return;
      dialog.dataset.motionWrapped = '1';

      var close = dialog.close.bind(dialog);

      dialog.close = function (value) {
        if (!dialog.open || dialog.hasAttribute('data-closing')) return;
        dialog.setAttribute('data-closing', '');

        var finished = false;
        var finish = function () {
          if (finished) return;
          finished = true;
          dialog.removeEventListener('transitionend', onEnd);
          dialog.removeAttribute('data-closing');
          close(value);
        };

        /* Three filters, and all three earned their place. `event.target` keeps
           out transitions finishing on the panel and its contents, which bubble
           through here on their own schedule. `pseudoElement` keeps out the
           scrim: `::backdrop` reports the dialog as its target and runs on the
           shorter `--dur-fast`, so in WebKit it ended the slide at ~240ms of a
           420ms move. `propertyName` keeps out everything else the closing
           state happens to change. */
        var onEnd = function (event) {
          if (event.target !== dialog) return;
          if (event.pseudoElement) return;
          if (event.propertyName !== 'transform') return;
          finish();
        };

        dialog.addEventListener('transitionend', onEnd);
        window.setTimeout(finish, FALLBACK_MS);
      };

      /* Escape reaches the dialog as `cancel` and the UA closes it itself
         straight afterwards, bypassing the method above. Take the close over. */
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        dialog.close();
      });
    };

    var scan = function () {
      document.querySelectorAll('dialog[data-motion-close]').forEach(wrap);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["footer-newsletter"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-newsletter]');
    if (!root) return;

    /* ---- The thank-you, and remembering it -------------------------------
       Shopify's `form.posted_successfully?` is true for exactly one page load:
       the redirect back from the post. Refresh and the form is asking again,
       which is what the owner noticed Jacquemus does not do.

       So the server-rendered success writes a flag, and every later load reads
       it. localStorage rather than a cookie: nothing here needs to reach the
       server, and a cookie on every request to carry one boolean is a cost the
       shopper pays on every page.

       Per browser, and permanent. Someone who subscribes on a phone still sees
       the form on a laptop, and someone who wants to change address has to use
       the account page — both are true of the reference too, and both are worth
       saying out loud rather than discovering later. */
    var KEY = 'etree:subscribed';
    var thanks = root.querySelector('[data-club-thanks]');

    var showThanks = function () {
      if (!thanks) return;
      thanks.hidden = false;
      root.classList.add('is-subscribed');
    };

    var remembered = false;
    try {
      remembered = window.localStorage.getItem(KEY) === '1';
    } catch (error) {
      /* Private windows and blocked site data throw on read. The form simply
         asks again, which is the old behaviour and not a failure. */
      remembered = false;
    }

    if (root.querySelector('[data-just-subscribed]')) {
      try {
        window.localStorage.setItem(KEY, '1');
      } catch (error) {
        /* Nothing to do — the thank-you still shows for this load. */
      }
      showThanks();
    } else if (remembered) {
      showThanks();
    }

    var input = root.querySelector('#newsletter-email');
    var button = root.querySelector('[data-newsletter-submit]');
    if (!input || !button) return;

    /* `checkValidity()` rather than a regular expression: the browser already
       owns what `type="email"` means, and every hand-written address pattern
       is wrong about something. The length test is what stops an empty field
       from ever counting — `required` makes it invalid, but this runs on every
       keystroke and the intent is "looks like an address", not "is non-empty". */
    var sync = function () {
      var ready = input.value.trim().length > 0 && input.checkValidity();
      button.classList.toggle('is-ready', ready);
    };

    /* The first press opens rather than submits. `capture`, so this runs before
       the validator bound on the form — otherwise a shut field reports itself
       required to a shopper who has not been shown it yet. */
    button.addEventListener('click', function (event) {
      if (root.classList.contains('is-open')) return;
      event.preventDefault();
      event.stopPropagation();
      root.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      /* Two frames: the row has to be laid out shut before the transition has a
         height to travel to. One is not enough — the PDP accordion waits twice
         for the same reason. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { input.focus(); });
      });
    }, true);

    input.addEventListener('input', sync);
    input.addEventListener('blur', sync);
    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-validate"] && !Shopify.designMode) return;
  try {
    (function () {
    var MOUNTED = 'etreeValidated';

    function fieldOf(input) {
      return input.closest('.field');
    }

    function messageFor(input, wrap) {
      var v = input.validity;
      if (v.valueMissing) return wrap.dataset.msgRequired || input.validationMessage;
      if (v.typeMismatch && input.type === 'email') {
        return wrap.dataset.msgEmail || input.validationMessage;
      }
      return input.validationMessage;
    }

    function clear(input) {
      var field = fieldOf(input);
      if (!field) return;
      field.classList.remove('field--error');
      input.removeAttribute('aria-invalid');
      var note = field.querySelector('[data-field-error]');
      if (note) note.remove();
      // Only drop the pointer we added; a field may legitimately describe
      // itself with something else.
      var describedBy = (input.getAttribute('aria-describedby') || '')
        .split(' ')
        .filter(function (id) { return id && id !== input.id + '-error'; })
        .join(' ');
      if (describedBy) input.setAttribute('aria-describedby', describedBy);
      else input.removeAttribute('aria-describedby');
    }

    function mark(input, wrap) {
      var field = fieldOf(input);
      if (!field) return;
      clear(input);
      field.classList.add('field--error');
      input.setAttribute('aria-invalid', 'true');

      var note = document.createElement('p');
      note.className = 'field__error';
      note.setAttribute('data-field-error', '');
      // Not role="alert": on submit several of these appear at once and a live
      // region would queue them all at the screen reader. The focus move to the
      // first invalid field, which is described by its own note, announces it.
      note.id = input.id + '-error';
      note.textContent = messageFor(input, wrap);
      field.appendChild(note);

      var describedBy = input.getAttribute('aria-describedby');
      input.setAttribute('aria-describedby', describedBy ? describedBy + ' ' + note.id : note.id);
    }

    function mount(wrap) {
      var form = wrap.querySelector('form');
      if (!form || form[MOUNTED]) return;
      form[MOUNTED] = true;

      // Ours from here, so the browser stops drawing its own.
      form.setAttribute('novalidate', 'novalidate');

      form.addEventListener('submit', function (event) {
        var invalid = [];
        var controls = form.querySelectorAll('input, textarea, select');
        for (var i = 0; i < controls.length; i++) {
          var control = controls[i];
          if (control.type === 'hidden' || control.disabled) continue;
          if (control.checkValidity()) clear(control);
          else {
            mark(control, wrap);
            invalid.push(control);
          }
        }
        if (!invalid.length) return;
        event.preventDefault();
        invalid[0].focus();
      });

      // Re-check as the shopper types, but only once a field has already been
      // told off. Validating on the first keystroke marks a half-typed address
      // as wrong before anyone has finished writing it.
      form.addEventListener('input', function (event) {
        var control = event.target;
        if (!fieldOf(control) || !fieldOf(control).classList.contains('field--error')) return;
        if (control.checkValidity()) clear(control);
        else mark(control, wrap);
      });
    }

    function init() {
      var wraps = document.querySelectorAll('[data-validate]');
      for (var i = 0; i < wraps.length; i++) mount(wraps[i]);

      // Shopify answers a rejected post with a fresh page load, which lands the
      // shopper at the top — and the newsletter sits in the footer, so the
      // reason they were sent back is a screen away. Bring it into view.
      var served = document.querySelector('[data-form-error]');
      if (served) served.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Sections re-render on their own in the theme editor.
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-veil"] && !Shopify.designMode) return;
  try {
    (function () {
    var veil = document.querySelector('[data-page-veil]');
    if (!veil) return;

    var shownAt = Date.now();
    var failsafe = null;

    function lift() {
      /* A 300ms floor so a warm cache never strobes it: a veil that appears and
         vanishes inside two frames reads as a flicker, not as a wait. */
      var held = Date.now() - shownAt;
      window.setTimeout(function () {
        veil.removeAttribute('data-open');
      }, Math.max(0, 300 - held));
      window.clearTimeout(failsafe);
    }

    function drop() {
      shownAt = Date.now();
      veil.setAttribute('data-open', '');
      /* If the hand-off never happens — a blocked navigation, a failed POST —
         the veil must not hold the page hostage. */
      window.clearTimeout(failsafe);
      failsafe = window.setTimeout(lift, 8000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', lift);
    } else {
      lift();
    }

    /* Restored from the back/forward cache with the veil as it was left — which,
       coming back from checkout, is open. */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) veil.removeAttribute('data-open');
    });

    /* The checkout hand-off. Adding to the bag is a thread under the button, not
       a veil over the page — this is only the step that leaves the storefront. */
    document.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.name === 'checkout') drop();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* One listener set per card, bound once for the page. This snippet renders
     many times — a grid, the related row, the homepage — but Shopify includes a
     snippet's script once, so this walks whatever is on the page rather than
     running per render.

     Nothing here is required for the track to work. Swipe, momentum and snap
     are the browser's; this adds the two arrows and moves the rail's tick. With
     the script gone the rail sits at zero and the arrows never appear, which is
     why the arrows are hidden until the script shows them. */
  (function () {
    var bind = function (card) {
      if (card.hasAttribute('data-card-bound')) return;
      var track = card.querySelector('[data-card-track]');
      if (!track) return;
      var slides = track.children.length;
      if (slides < 2) return;
      card.setAttribute('data-card-bound', '');

      var tick = card.querySelector('[data-card-tick]');
      var prev = card.querySelector('[data-card-prev]');
      var next = card.querySelector('[data-card-next]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      /* Round rather than floor: a snap point lands a fraction of a pixel out
         often enough that a floor leaves the tick one slide behind at the end
         of the track. */
      var indexNow = function () {
        var w = track.clientWidth || 1;
        return Math.max(0, Math.min(slides - 1, Math.round(track.scrollLeft / w)));
      };

      var queued = false;
      var sync = function () {
        queued = false;
        var i = indexNow();
        if (tick) tick.style.transform = 'translateX(' + i * 100 + '%)';
        if (prev) prev.toggleAttribute('hidden', i === 0);
        if (next) next.toggleAttribute('hidden', i === slides - 1);
      };

      track.addEventListener('scroll', function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(sync);
      }, { passive: true });

      var step = function (dir) {
        track.scrollBy({
          left: dir * track.clientWidth,
          behavior: reduce.matches ? 'auto' : 'smooth'
        });
      };

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      window.addEventListener('resize', sync, { passive: true });
      sync();
    };

    var scan = function (root) {
      (root || document).querySelectorAll('.product-card').forEach(bind);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }

    /* Filtering replaces the grid through the Section Rendering API, and the
       related row and the search panel render cards after first paint. Rebind
       rather than hope. */
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('etree:cards-rendered', function (event) {
      scan(event.target && event.target.nodeType === 1 ? event.target : document);
    });

    window.etreeProductCards = scan;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-lightbox"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.querySelector('[data-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var image = dialog.querySelector('[data-lightbox-image]');
    var closeButton = dialog.querySelector('[data-lightbox-close]');

    var SCALE = 2.4;
    var pan = { x: 0, y: 0 };
    var drag = null;

    function reset() {
      image.removeAttribute('data-zoomed');
      image.style.transform = '';
      pan = { x: 0, y: 0 };
    }

    function open(source) {
      var src = source.getAttribute('data-zoom-src');
      if (!src) return;
      image.style.backgroundImage = 'url("' + src + '")';
      image.setAttribute('aria-label', source.getAttribute('data-zoom-alt') || '');
      reset();
      dialog.showModal();
    }

    /* Delegated, because the gallery hides and shows slides as the colour
       changes and re-binding per slide would miss the ones added later. */
    document.addEventListener('click', function (event) {
      var source = event.target.closest ? event.target.closest('[data-zoom-src]') : null;
      if (source) open(source);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var source = event.target.closest ? event.target.closest('[data-zoom-src]') : null;
      if (!source) return;
      event.preventDefault();
      open(source);
    });

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        dialog.close();
      });
    }

    dialog.addEventListener('close', reset);

    /* The plate is 96vw x 92vh inside a full-viewport dialog, so there is a
       band of white around it that is the dialog itself. "Click anywhere
       closes" has to mean that band too, not just the photograph. Guarded on
       the close button so its own click is not counted twice. */
    dialog.addEventListener('click', function (event) {
      if (event.target === image) return;
      if (closeButton && closeButton.contains(event.target)) return;
      dialog.close();
    });

    image.addEventListener('click', function (event) {
      /* A drag ends in a click. Panning to the hem and having the photo snap
         back out is the bug this guard exists for. */
      if (drag && drag.moved) return;

      if (image.hasAttribute('data-zoomed')) {
        reset();
        return;
      }

      var rect = image.getBoundingClientRect();
      image.style.transformOrigin =
        ((event.clientX - rect.left) / rect.width) * 100 + '% ' +
        ((event.clientY - rect.top) / rect.height) * 100 + '%';
      pan = { x: 0, y: 0 };
      image.style.transform = 'scale(' + SCALE + ')';
      image.setAttribute('data-zoomed', '');
    });

    image.addEventListener('pointerdown', function (event) {
      if (!image.hasAttribute('data-zoomed')) return;
      drag = { x: event.clientX, y: event.clientY, px: pan.x, py: pan.y, moved: false };
      image.setPointerCapture(event.pointerId);
    });

    image.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var dx = event.clientX - drag.x;
      var dy = event.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) drag.moved = true;
      pan = { x: drag.px + dx, y: drag.py + dy };
      /* The translate is divided by the scale so a 100px drag moves the photo
         100px on screen, not 240. */
      image.style.transform =
        'scale(' + SCALE + ') translate(' + pan.x / SCALE + 'px, ' + pan.y / SCALE + 'px)';
    });

    image.addEventListener('pointerup', function () {
      /* Cleared after the click event that follows this pointerup, not before. */
      setTimeout(function () {
        drag = null;
      }, 0);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.getElementById('size-guide-modal');
    if (!dialog) return;

    var openers = document.querySelectorAll('[data-size-guide-open]');

    openers.forEach(function (opener) {
      opener.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        opener.setAttribute('aria-expanded', 'true');
      });
    });

    /* The backdrop is the dialog's own pseudo-element, so a click on it reports
       the dialog as the target — which the panel inside never does. */
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () {
      openers.forEach(function (opener) {
        opener.setAttribute('aria-expanded', 'false');
      });
    });

    dialog.querySelectorAll('[data-size-guide-close]').forEach(function (closer) {
      closer.addEventListener('click', function () {
        dialog.close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-panel"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-size-guide]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-size-guide-tab]');
      var groups = root.querySelectorAll('[data-size-guide-panel]');

      function showTab(key) {
        tabs.forEach(function (tab) {
          tab.setAttribute('aria-selected', tab.getAttribute('data-size-guide-tab') === key ? 'true' : 'false');
        });
        groups.forEach(function (group) {
          group.hidden = group.getAttribute('data-size-guide-panel') !== key;
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          showTab(tab.getAttribute('data-size-guide-tab'));
          /* A new product has its own pieces; carry the requested size over so
             the drawings land on the same one where it exists. */
          applyActiveSize(root.getAttribute('data-active-size'));
        });
      });

      /* Callouts are matched to cells by column name, not by position: a dress
         has four columns and a cape has two, and the same drawing is never
         reused across two column sets. A column with no callout on that shape
         simply has nowhere to write, which is not an error. */
      function paintPiece(piece, row) {
        piece.querySelectorAll('[data-size-guide-callout]').forEach(function (callout) {
          var name = callout.getAttribute('data-size-guide-callout');
          var cell = row.querySelector('[data-size-guide-col="' + name + '"]');
          callout.textContent = cell ? cell.textContent.trim() + ' cm' : '';
        });
      }

      function applyActiveSize(wanted) {
        root.querySelectorAll('.size-guide__piece').forEach(function (piece) {
          var rows = piece.querySelectorAll('[data-size-guide-row]');
          if (!rows.length) return;

          var match = null;
          rows.forEach(function (row) {
            if (!match && wanted && row.getAttribute('data-size-guide-row') === wanted) match = row;
          });
          if (!match) match = rows[0];

          rows.forEach(function (row) {
            row.setAttribute('aria-current', row === match ? 'true' : 'false');
          });
          paintPiece(piece, match);
        });
      }

      /* One size runs through every piece of a set: picking M on the trouser
         moves the corset and the cape too, because she is buying one size. */
      root.querySelectorAll('[data-size-guide-row]').forEach(function (row) {
        row.addEventListener('click', function () {
          root.setAttribute('data-active-size', row.getAttribute('data-size-guide-row'));
        });
      });

      /* The product page moves the panel by writing the attribute rather than
         calling in, so neither has to hold a reference to the other. */
      new MutationObserver(function () {
        applyActiveSize(root.getAttribute('data-active-size'));
      }).observe(root, { attributes: true, attributeFilter: ['data-active-size'] });

      applyActiveSize(root.getAttribute('data-active-size'));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
